export const DEPENDENTS_SEARCH_THRESHOLD = 5;
export const DEFAULT_INCLUDE_PERSONAL_COLLECTIONS = true;
export const TOOLTIP_OPEN_DELAY_MS = 700;
